module.exports = __webpack_public_path__ + "static/media/a.b8d015b1.jpg";